angular.module("delegationRequest.components", []).component("delegationRequest", {
    templateUrl: "ng/components/delegationRequest/delegationRequest.view.html",
    bindings: {
        richiestePostVendita: "<"
    },
    controllerAs: "delegationRequestCtrl",
    controller: function DelegationRequest(
        $location,
        $arcService,
        $modalService,
        $RichiestePostVenditaService,
        $rootScope,
        Contratti
    ) {
        var self = this;

        self.$onInit = function () {
            self.supportModel = {
                loading: false,
                restDownloadRunning: false,
                listOfDocumentDownload: [],
                visibleDownloadChecklist: false,
                restUploadRunning: false,
                listOfDocumentUpload: [],
                visibleUploadChecklist: false
            }

            if (self.richiestePostVendita.viewIndex == 0) {
                self.richiestePostVendita.viewIndex = 1400;
            }

            var contratti = [];
            if (self.richiestePostVendita.metadata.delega.contratti.length == 0) {
                self.richiestePostVendita.metadata.ctrRichiestaList.forEach(function (contratto) {
                    contratti.push(Contratti.build({
                        numero: contratto.numeroContratto,
                        modulo: contratto.numeroModulo,
                        selected: true,
                        codProdotto: contratto.codProdotto
                    }));
                });

                self.richiestePostVendita.metadata.delega.contratti = contratti;
            }

            if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCK1') {
                popolateCheckListDownload();
                popolateCheckListUpload();
            }
        };

        self.validityPage = function (validity) {
            self.munAuthComponent = validity;
        }

        self.nextValidity = function () {
            return self.munAuthComponent;
        }

        self.backValidity = function () {
            return (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PAI3') ? false : true;
        }

        self.closeModal = function () {
            $modalService.closeModal("suspendInstance");
        }

        self.next = function () {
            self.supportModel.nextStep = true;
            if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PAI3') {
                $RichiestePostVenditaService
                    .nextStep(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                    .then(function (response) {
                        self.supportModel.nextStep = false;
                        self.richiestePostVendita = response;

                        if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCK1') {
                            popolateCheckListDownload();
                            popolateCheckListUpload();
                        }

                    }).catch(function (error) {
                        console.log(error);
                        self.supportModel.nextStep = false;
                    });
            } else if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCK1') {
                $RichiestePostVenditaService
                    .delegheComCat(self.richiestePostVendita.metadata.delega, self.richiestePostVendita.id, self.richiestePostVendita.viewIndex,
                        self.richiestePostVendita.applicationName, self.richiestePostVendita.typeWf)
                    .then(function (response) {
                        self.supportModel.nextStep = false;
                        $location.path('/');
                    }).catch(function (error) {
                        console.log(error);
                        self.supportModel.nextStep = false;
                    });
            }
        }

        self.back = function () {
            $RichiestePostVenditaService
                .backStep(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                .then(function (response) {
                    self.supportModel.nextStep = false;
                    self.richiestePostVendita = response;
                }).catch(function (error) {
                    console.log(error);
                    self.supportModel.nextStep = false;

                })
        }

        self.sospendi = function () {
            $RichiestePostVenditaService
                .suspendInstance(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                .then(function () {
                    $location.path('/');
                    $modalService.closeModal("suspendInstance");
                })
        }

        var popolateCheckListDownload = function () {
            self.supportModel.restDownloadRunning = true;
            $arcService.downloadDocumentationRichiestaPostVendita(self.richiestePostVendita)
                .then(function (response) {
                    self.supportModel.listOfDocumentDownload = response.listDocuments;
                    self.supportModel.visibleDownloadChecklist = response.visible;
                    self.supportModel.restDownloadRunning = false;
                })
                .catch(function (error) {
                    console.error(error);
                    self.restDownloadRunning = false;
                })
        }

        var popolateCheckListUpload = function () {
            self.supportModel.restUploadRunning = true;
            $arcService.uploadDocumentationRichiestaPostVendita(self.richiestePostVendita)
                .then(function (response) {
                    self.supportModel.listOfDocumentUpload = response.listDocuments;
                    self.supportModel.visibleUploadChecklist = response.visible;
                    self.message = response.message;
                    self.supportModel.restUploadRunning = false;
                })
                .catch(function (error) {
                    console.error(error);
                    self.supportModel.restUploadRunning = false;
                })
        }

        self.getWizardMap = function (viewIndex) {
            if (
                $rootScope.wizardMap.find(function (element) {
                    return element.index == viewIndex;
                })
            ) {
                return $rootScope.wizardMap.find(function (element) {
                    return element.index == viewIndex;
                }).viewName;
            }
        };
    }
});